import { Component, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

export interface Modal {
  list: string[];
  title: string;
  actionButtonText: string;
  id: number;
  btnClass: string;
  okOnly?: boolean;
}

@Component({
  selector: 'app-modalbox',
  templateUrl: './modalbox.component.html',
})
export class ModalboxComponent implements Modal {
  list: string[];
  title: string;
  actionButtonText: string;
  id = 0;
  btnClass: string;
  okOnly: boolean;
  closeOnly: boolean;
  event: EventEmitter<number> = new EventEmitter();

  constructor(public bsModalRef: BsModalRef) {}

  action() {
    this.event.emit(this.id);
    this.bsModalRef.hide();
  }

  close() {
    this.bsModalRef.hide();
  }

  onTypeChange(item: string) {
    this.id = item.includes('Append Stops to Route') ? 0 : 1;
  }
}
